import React, { useState, useEffect } from "react";
import Datatable from "../../component/datatable/Datatable";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS;

export default function LateFiles() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    const refreshList = () => {
        Axios.get(`${backEndUrl}/auth/consultantLog`, {
            withCredentials: true,
        }).then((res) => {
            // Filter for late clients
            const allClients = res.data.clients || [];
            const lateClients = allClients.filter(c => c.fileStatus === 'late' && c.archive === false);
            setData(lateClients);
        }).catch((err) => console.error("Failed to fetch clients", err));
    };

    useEffect(() => {
        refreshList();
    }, []);

    useEffect(() => {
        const handleClientEvent = (event) => {
            const { type } = event.detail;
            if (type === 'REFRESH_ALL' || type === 'ADD' || type === 'UPDATE_REAL_ID') {
                refreshList();
            }
        };
        window.addEventListener('CLIENT_ACTION', handleClientEvent);
        return () => window.removeEventListener('CLIENT_ACTION', handleClientEvent);
    }, []);

    return (
        <div className="p-6">
            <div className="mb-6">
                <button onClick={() => navigate(-1)} className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 hover:bg-slate-200 transition mb-4">
                    <ArrowLeft className="h-4 w-4" />
                </button>
                <h1 className="text-3xl font-bold text-gray-900">Action Needed</h1>
                <p className="text-gray-600 mt-1">Files flagged as late</p>
            </div>
            <Datatable 
                clients={data} 
                mode="full"
            />
        </div>
    );
}
